import { importedQuestionModel } from './imported-question-model.js';

export const overrideQuestionModel = {
  opinionOptions: [ 
    { value: 5, text: "Strongly disagree" },
    { value: 4, text: "Slightly disagree" },
    { value: 3, text: "Neutral" },
    { value: 2, text: "Slightly agree" },
    { value: 1, text: "Strongly agree" }
  ],

  // TODO - move entire list to spreadsheet, as a UI table
  questions: [
    {
      id: 'B1', 
      title: 'Stories',
      type: 'radio',
      items: [{ value: 102 }, { value: 101 }, { value: 103 }],
      hasImages: true
    },
    {
      id: 'D1',
      title: 'Construction Year',
      type: 'radio',
      items: [{ value: 101, title: "Pre-1980" }, { value: 102, title: "Post-1980" }],
      hasImages: false
    },
    {
      id: 'B2', 
      title: 'Wall Types',
      type: 'radio',
      items: [{ value: 202 }, { value: 203 }, { value: 201 }, { value: 204 }, { value: 205 }],
      hasImages: true
    },
    {
      id: 'C1',
      title: 'Windows',
      type: 'radio',
      items: [{value: 101}, {value: 102}, {value: 103}, {value: 104}, {value: 105}, {value: 106}],
      hasImages: true
    },
    {
      id: 'C2',
      title: 'Windows',
      type: 'radio',
      items: [{value: 201}, {value: 202}, {value: 203}, {value: 204}, {value: 206}],
      hasImages: true
    },
    {
      id: 'D2',
      title: 'Roof Age',
      type: 'radio',
      items: [{value: 202}, {value: 203}, {value: 204}, {value: 205}],
      hasImages: false
    },
    {
      id: 'D3',
      title: 'Roof Shape',
      type: 'radio',
      items: [{value: 301}, {value: 302}, {value: 303}, {value: 304}],
      hasImages: true
    },
    {
      id: 'D4',
      title: 'Roof Material',
      type: 'radio',
      items: [{value: 401}, {value: 402}, {value: 403}, {value: 404}],
      hasImages: false
    },
    {
      id: 'D5',
      title: 'Roof Proofing',
      type: 'radio',
      items: [{value: 501}, {value: 502}, {value: 503}],
      hasImages: false
    },
    {
      id: 'D6',
      title: 'Roof',
      type: 'radio',
      items: [{value: 601}, {value: 602}, {value: 603}],
      hasImages: true
    },
    {
      id: 'D7',
      title: 'Roof Over Batten',
      type: 'radio',
      items: [{value: 701}, {value: 702}],
      hasImages: false
    },
    {
      id: 'D8',
      title: 'Roof Seaming',
      type: 'radio',
      items: [{value: 801}, {value: 802}],
      hasImages: false
    },
    {
      id: 'C3',
      title: 'Roller Door',
      type: 'radio',
      items: [{value: 304, title: "After Market Bracing Upgrade"}, {value: 303, title: "I use a DIY solution"}, {value: 301, title: "No work has been done"}],
      hasImages: true,
      headline: 'Roller door bracing',
      hint: "Has any work been done to brace your roller door for cyclones?",
    },
    {
      // To Do: move item titles to imported-question-model.js (i.e. to spreadsheet)
      id: 'A1',
      title: 'Preparation',
      type: 'flags',
      items: [{value: 1, title: "Secure outdoor items"}, {value: 2, title: "Clean yard / prune trees"}, {value: 4, title: "Cyclone prep kit"}],
      hasImages: false,
      headline: 'Do you prepare for cyclones?'
    },
    {
      id: 'A2',
      title: 'Shed',
      type: 'radio',
      items: [{value: 201}, {value: 202}, {value: 203}, {value: 204}, {value: 205}, {value: 207}],
      hasImages: false
    },
    {
      id: 'E1to4',
      title: 'Cyclone Talk',
      type: 'scores',
      headline: 'Tell us how you feel about the following statements.',
      scoreType: 'opinion',
      items: [
        { id: 'E1', offset: 100 },
        { id: 'E2', offset: 200 },
        { id: 'E3', offset: 300 },
        { id: 'E4', offset: 400 },
      ]
    },
    {
      id: 'E5to7',
      title: 'Cyclone Experiences',
      type: 'scores',
      headline: 'Tell us a little about your experience with cyclones.',
      scoreType: 'opinion',
      items: [
        { id: 'E5', offset: 500, text: 'Have you experienced a cyclone in the past? If more than one, select the most recent.', 
          scores: [{ value: 1, text: 'Debbie' }, { value: 2, text: 'Marcia' }, { value: 3, text: 'Yasi' }, { value: 4, text: 'Other' }, { value: 5, text: 'No' }] },
        { id: 'E6', offset: 600, text: 'Were you living in the same location as you are now when you experienced the cyclone?', 
          scores: [{ value: 1, text: 'Yes' }, { value: 2, text: 'No' }, { value: 3, text: 'N/A' }] },
        { id: 'E7', offset: 700, text: 'Based on what you remember about the cyclone, what were the category level winds that your town/city experienced?', 
          scores: [{ value: 1, text: 'Cat 1' }, { value: 2, text: 'Cat 2' }, { value: 3, text: 'Cat 3' }, { value: 4, text: 'Cat 4' }, { value: 5, text: 'Cat 5' }, { value: 6, text: 'N/A' }] },
      ]
    },
    {
      id: 'E8to9',
      title: 'Cyclone Expectations',
      type: 'scores',
      headline: 'What do you expect?',
      scoreType: 'opinion',
      items: [
        { id: 'E8', offset: 800, 
          scores: [{ value: 1, text: 'None' }, { value: 2, text: 'Minor' }, { value: 3, text: 'Moderate' }, { value: 4, text: 'Severe' }, { value: 5, text: 'Total' }] },
        { id: 'E9', offset: 900 , 
          scores: [{ value: 1, text: '<20%' }, { value: 2, text: '20-40%' }, { value: 3, text: '40-60%' }, { value: 4, text: '60-80%' }, { value: 5, text: '>80%' }] },
      ]
    },
  ],

  defaultScoreOptions: function() { return this.opinionOptions },

  getOptionsForQuestion: function(oq) {
    switch (oq.scoreType) {
      case 'opinion':
        return this.opinionOptions
      default:
        return this.defaultScoreOptions()
    }
  },

  getOptionsForQuestionItem: function(oq, item) {
    if (item.scores) {
      return item.scores
    }
    else {
      return this.getOptionsForQuestion(oq)
    }
  },

  enrichQuestion: function(oq) {
    let iq = importedQuestionModel['model' + oq.id]
    // One-to-one match between imported and override models
    if (iq) {
      return {
        id: iq.id,
        type: oq.type,
        title: oq.title,
        headline: oq.headline ? oq.headline : iq.questionTitle,
        hint: oq.hint ? oq.hint : iq.questionSupportText,
        items: oq.items.map(oi => {
          let ii = iq.items.find(iqi => (oq.type == 'radio' && iqi.value == oi.value)
            || (oq.type == 'flags' && iqi.flags == oi.value))
          return {
            id:    ii.id,
            value: oi.value,
            title: oi['title'] ? oi['title'] : ii.description
          }
        }),
        hasImages: oq.hasImages,
        // Source info
        iq: iq,
        oq: oq
      }
    }
    else if (oq.type == 'scores') {
      let iqs = oq.items.map(ii => importedQuestionModel['model' + ii.id])
      return {
        id: oq.id,
        type: oq.type,
        title: oq.title,
        headline: oq.headline,
        hint: null,
        items: oq.items.map(oi => {
          // { id: 'E1', offset: 100 },
          let iq = iqs.find(iqi => iqi.id == oi.id)
          return {
            id:       iq.id,
            headline: oi.text ? oi.text : iq.questionSupportText,
            offset:   oi.offset,
            options:  oi.scores ? oi.scores : this.getOptionsForQuestion(oq),
            // Source info
            iq:       iq
          }
        }),
        hasImages: false,
        // Source info
        oq: oq
      }
    }
  } ,

  enrichModel: function() {
    return this.questions.map(oq => this.enrichQuestion(oq))
  },

  getEnrichedQuestion: function(id) {
    let oq = this.questions.find(q => q.id == id)
    return this.enrichQuestion(oq)
  },

  getEnums: function() {
    var enums = []
    this.questions.forEach(oq => {
      // console.log('getEnums ' + oq.id)
      if (oq.type == 'radio') {
        enums.push( { id: oq.id, which: -1, userSet: false } )
      }
      else if (oq.type == 'flags') {
        oq.items.map((item, index) => { 
          return { id: oq.id + "_" + index, which: -1, userSet: false, 
            parentId: oq.id, flagValue: item.value, index: index,
            title: item.title } 
          }).forEach(e => {enums.push( e )})
      }
      else if (oq.type == 'scores') {
        oq.items.map((item, index) => {
          return { id: item.id, which: -1, userSet: false, 
            parentId: oq.id, index: index, 
            title: item.text ? item.text : importedQuestionModel['model' + item.id].questionSupportText }
          }).forEach(e => {enums.push( e )})
      }
    })
    // console.log(enums)
    return enums
    
    //return this.questions.map(oq => { return {id: oq.id, which: -1, userSet: false} })
  },
  
  flagsToIndex: function(eq, flagArray) {
    var sum = 0
    for (var i = 0; i < flagArray.length; i++) {
      if (flagArray[i] < 0) {
        return -1 // any unknown => all unknown
      }
      sum += eq.items[i].value * (flagArray[i] == 1)
    }
    return eq.iq.items.findIndex(ii => ii.flags == sum)
  },
  indexToFlags: function(eq, index) {
    var flagSum = (index < 0) ? -1 : eq.iq.items[index].flags
    var flags = []
    for (var i = 0; i < eq.items.length; i++) {
      flags.push(flagSum == -1 ? -1 : ((flagSum & eq.items[i].value) ? 1 : 0))
    }
    return flags
  },
  flagsIdToFlags: function(oq, flagsId) {
    let eq = this.enrichQuestion(oq)
    var index = eq.iq.items.findIndex(i => i.id == flagsId)
    return this.indexToFlags(eq, index)
  },
  flagsValueToFlags: function(oq, flagsValue) {
    let eq = this.enrichQuestion(oq)
    var index = eq.iq.items.findIndex(i => i.value == flagsValue)
    return this.indexToFlags(eq, index)
  }
  
}

export default overrideQuestionModel;
